module.exports = require("@swa-ui/itinerary/src/FlightAirlineOperator/FlightAirlineOperator.module.scss");